<template>
  <div class="l_alert__invitation_get_failure animation__background">
    <div class="l_alert__panel animation__popup">
      <div class="container">
        <div class="title">
          <p>申し訳ございません。<br>
            お友だち紹介スタンプが<br>
            受け取れませんでした。</p>
        </div>
        <img class="l_img" :src="require('@/assets/img/install-info.svg')" />
        <p class="description description-title">
          以下の場合はスタンプを獲得できません。
        </p>
        <p v-if="inviteeExpireDays > 6" class="description">
          ●期限切れ（紹介メール送信から{{Math.floor(inviteeExpireDays / 7)}}週間）<br>
          ●紹介スタンプをすでに受け取り済み<br>
          ●以前から本アプリを使っていた
        </p>
        <p v-else class="description">
          ●紹介スタンプをすでに受け取り済み<br>
          ●以前から本アプリを使っていた
        </p>
        <div class="footer">
          <button @click="tapClose">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertInvitationGetFailure',
  props: {
    inviteeExpireDays: { type: Number }
  },
  methods: {
    tapClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.l_alert__invitation_get_failure {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_alert__panel {
  width: 270px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.l_alert__invitation_get_failure .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: #ffffff;
  padding: 20px 0 0 0;
}

.l_alert__invitation_get_failure .container .title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.l_img {
  width: 90px;
  height: 90px;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 20px;
}
.freepass {
  height: 175px !important;
}

.c_img {
  max-width: 100%;
  vertical-align: bottom;
}

.l_alert__invitation_get_failure .container .description-title {
  padding-bottom: 6px;
  text-align: center;
}

.l_alert__invitation_get_failure .container .description {
  font-family: 'HiraKakuPro-W3';
  font-size: 12px;
  text-align: start;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #333333;
}

.l_alert__invitation_get_failure.container .description p:nth-child(1) {
  padding-top: 20px;
}

.l_alert__invitation_get_failure .container .description .txt-highlight {
  color: #e03535;
}

.l_alert__invitation_get_failure .container .footer {
  padding-top: 25px;
  width: 100%;
}

.l_alert__invitation_get_failure .container .footer button {
  font-family: 'HiraKakuPro-W3';
  font-size: 13px;
  text-align: center;
  background-color: #ffffff;
  color: #602209;
  width: 100%;
  padding: 12px 0;
  outline: none;
  border-radius: 12px;
}

.l_alert__invitation_get_failure .container .footer button:nth-child(1) {
  border: none;
  border-top: 1px solid #eeeeee;
}
</style>
